import React, {useEffect} from 'react';

import {useHistory} from 'react-router-dom';

import Router from 'router/router';
import * as css from './css/cart';
import {observer} from 'mobx-react';
import useMyStores from "@/hooks/useMyStores";
import useUserState from "hooks/useUserState.ts";


function Cart({className}) {

    const history = useHistory()
    const {login, cart} = useMyStores()
    const userState = useUserState()

    useEffect(() => {
        if (userState.token) {
            cart.fetchGoodsCount().then();
        }
    }, [userState.token]);

    return (
        <css.Cart
            className={className}
            onClick={() => {
                if (userState.token) {
                    history.push({
                        pathname: Router.Cart.path
                    });
                } else {
                    login.show = true;
                }
            }}
        >
            <css.CartContainer>
                <div className='bg-img-wrapper'>
                    <img src={require('./img/bg.png')} alt='' className='bg-img'/>
                </div>
                {cart.goodsCount > 0 && (
                    <css.MessageBlock>{cart.goodsCount}</css.MessageBlock>
                )}
            </css.CartContainer>
            <css.Title>我的购物车</css.Title>
        </css.Cart>
    );
}

export default observer(Cart);
